module.exports = __webpack_public_path__ + "img/logo.fa1f00d4.png";